module.exports = __webpack_public_path__ + "static/media/whiteFilterIcon.cc5312ce.svg";